const deepClone = (regions: any) => {
  return JSON.parse(JSON.stringify(regions));
};

export default deepClone;
